export interface MatchOdds {
  back: string;
  lay: string;
}

export interface Match {
  id: string;
  name: string;
  time?: string;
  inPlay: boolean;
  bookmaker: boolean;
  fancy: boolean;
  sportbook: boolean;
  odds1: MatchOdds;
  oddsX: MatchOdds;
  odds2: MatchOdds;
}

export const MOCK_HIGHLIGHT_MATCHES: Match[] = [
  {
    id: '3544687543453',
    name: 'Ball By Ball',
    inPlay: true,
    bookmaker: false,
    fancy: false,
    sportbook: true,
    odds1: { back: '2.18', lay: '0' },
    oddsX: { back: '7.92', lay: '0' },
    odds2: { back: '2.62', lay: '0' }
  },
  {
    id: '4002026324132512521',
    name: 'Pakistan Super League - Winner',
    time: '26-03-2026 11:00',
    inPlay: false,
    bookmaker: true,
    fancy: false,
    sportbook: false,
    odds1: { back: '1.42', lay: '950' },
    oddsX: { back: '1.18', lay: '0' },
    odds2: { back: '1.18', lay: '4.9' }
  },
  {
    id: '4002026316142038378',
    name: 'Indian Premier League - Winner',
    time: '28-03-2026 10:00',
    inPlay: false,
    bookmaker: false,
    fancy: true,
    sportbook: false,
    odds1: { back: '3.35', lay: '3.4' },
    oddsX: { back: '6.8', lay: '7' },
    odds2: { back: '4.6', lay: '4.8' }
  },
  {
    id: '400202391695222640',
    name: 'testing2 vs testing3',
    time: '16-04-2026 2:50',
    inPlay: false,
    bookmaker: false,
    fancy: true,
    sportbook: false,
    odds1: { back: '0', lay: '0' },
    oddsX: { back: '0.0', lay: '0.0' },
    odds2: { back: '0', lay: '0' }
  },
  {
    id: '400202642171336991',
    name: 'Bangladesh W v Sri Lanka W',
    inPlay: true,
    bookmaker: true,
    fancy: true,
    sportbook: true,
    odds1: { back: '0', lay: '0' },
    oddsX: { back: '0.0', lay: '0.0' },
    odds2: { back: '0', lay: '0' }
  },
  {
    id: '4002026419125647849',
    name: 'Karachi Kings v Peshawar Zalmi',
    inPlay: true,
    bookmaker: true,
    fancy: true,
    sportbook: true,
    odds1: { back: '2.44', lay: '2.48' },
    oddsX: { back: '0.0', lay: '0.0' },
    odds2: { back: '1.67', lay: '1.69' }
  },
  {
    id: '4002026419125914188',
    name: 'Lucknow Super Giants v Rajasthan Royals',
    time: '22-04-2026 10:00',
    inPlay: false,
    bookmaker: true,
    fancy: true,
    sportbook: true,
    odds1: { back: '2.28', lay: '2.32' },
    oddsX: { back: '0.0', lay: '0.0' },
    odds2: { back: '1.76', lay: '1.78' }
  },
  {
    id: '400202642112052148',
    name: 'Hyderabad Kingsmen v Multan Sultans',
    time: '22-04-2026 10:00',
    inPlay: false,
    bookmaker: true,
    fancy: true,
    sportbook: true,
    odds1: { back: '2.22', lay: '2.4' },
    oddsX: { back: '0.0', lay: '0.0' },
    odds2: { back: '1.72', lay: '1.8' }
  },
  {
    id: '4002026420324238',
    name: 'South Africa W v India W',
    time: '22-04-2026 12:00',
    inPlay: false,
    bookmaker: true,
    fancy: true,
    sportbook: true,
    odds1: { back: '2.34', lay: '2.44' },
    oddsX: { back: '0.0', lay: '0.0' },
    odds2: { back: '1.69', lay: '1.74' }
  },
  {
    id: '40020264215243456',
    name: 'Bangladesh v New Zealand',
    time: '23-04-2026 1:00',
    inPlay: false,
    bookmaker: true,
    fancy: true,
    sportbook: true,
    odds1: { back: '0', lay: '0' },
    oddsX: { back: '0.0', lay: '0.0' },
    odds2: { back: '0', lay: '0' }
  }
];

export interface TipPreview {
  id: string;
  title: string;
  summary: string;
  date: string;
  content: string;
}

export const MOCK_TIPS_PREVIEWS: TipPreview[] = [
  {
    id: '1',
    title: 'MI vs CSK, IPL 2026: Samson, Hosein seal comfortable win for Super Kings',
    summary: 'Sanju Samson stars as CSK pull off an incredible victory against MI.',
    date: '27 April 2026',
    content: 'Details a CSK win by 103 runs, highlighting Sanju Samson\'s century and exceptional bowling performance by Akeal Hosein. The match was dominated by Chennai Super Kings from the get-go, securing their spot at the top of the table.'
  },
  {
    id: '2',
    title: 'Italy dismisses replacing Iran at the World Cup after suggestion by Trump official',
    summary: 'Italian sports officials decline a suggestion regarding World Cup participation.',
    date: '26 April 2026',
    content: 'Italian football authorities have completely dismissed any suggestion that the national team could replace Iran at the upcoming World Cup, following remarks made by a former US official. The federation emphasized their commitment to sporting integrity.'
  },
  {
    id: '3',
    title: 'EPL Weekend Preview: Arsenal travel to Anfield',
    summary: 'A crucial clash at the top of the Premier League table this Sunday.',
    date: '25 April 2026',
    content: 'Arsenal will face their toughest test of the season when they travel to Anfield to take on Liverpool. With both teams fighting for the title, this match could prove decisive in the race for the Premier League crown.'
  }
];
